export default __webpack_public_path__ + "static/media/quiz_pillar_one.72c79a85.png";